import React, { useEffect, useRef, useState } from "react";
import {
  cleanSpecialCharacters,
  parseFloatToFixed,
  translateDiscountType,
} from "../../../../extras";

// TYPES
import { ORDER_WITH_FULL_PAYMENTS } from "../../../../types/alerts";
// UTILS
import { dispatchAddAlert } from "../../../../utils/alerts";
// APP COMPONENTS
import ConfirmModal from "../../../modals/confirmModal";
import AddDiscountModal from "./Modals/addDiscountModal";
import AddPaymentMethodModal from "./Modals/addPaymentMethodModal";
// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { IconStackButtonFullHeight } from "../../../styled/button";
// ICONS
import DiscountIcon from "@mui/icons-material/Discount";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// COLORS
import { grey } from "@mui/material/colors";
import { DarkGreyBox } from "../../../styled";
import { formatFinance } from "../../../../utils/formatters";

export default function FinanceForm({
  total,
  totalToPay,
  discounts,
  setDiscounts,
  removeDiscounts,
  allowDiscountEdit = true,
  isEdit = false,
  paymentMethods,
  setPaymentMethods,
  continueAction,
}) {
  const isFirstRender = useRef(true);

  const [methods, setMethods] = useState(paymentMethods || []);
  const [showAddPaymentMethodModal, setShowAddPaymentMethodModal] =
    useState(false);

  const [discountsSelected, setDiscountsSelected] = useState(discounts);
  const [showAddDiscountModal, setShowAddDiscountModal] = useState(false);

  const [
    showConfirmDeletePaymentMethodModal,
    setShowConfirmDeletePaymentMethodModal,
  ] = useState(false);
  const [paymentMethodToDelete, setPaymentMethodToDelete] = useState(false);

  const [amountToPay, setAmountToPay] = useState(totalToPay || 0);

  useEffect(() => {
    if (!totalToPay) {
      return;
    }

    if (!methods || methods.length === 0) {
      setAmountToPay(totalToPay);
    } else {
      const methodsAmount = methods.reduce(
        (acc, method) =>
          acc + Number(parseFloatToFixed(method.amount || method.value)),
        0
      );
      setAmountToPay(totalToPay - methodsAmount);
    }
  }, [totalToPay, methods]);

  useEffect(() => {
    console.log("methods", methods);
    if (methods.length > 0) {
      const paymentMethodsSum = methods.reduce(
        (acc, method) =>
          acc + Number(parseFloatToFixed(method.amount || method.value)),
        0
      );

      const updatedAmountToPay = totalToPay - paymentMethodsSum;
      setAmountToPay(updatedAmountToPay);
      setPaymentMethods(methods);
    } else {
      setAmountToPay(totalToPay);
    }
  }, [methods]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (allowDiscountEdit) {
      if (discountsSelected.length > 0) {
        setMethods([]);
      }
    }
  }, [discountsSelected, allowDiscountEdit]);

  const addPaymentMethod = (paymentMethod) => {
    console.log("addPaymentMethod paymentMethod", paymentMethod);
    if (Array.isArray(paymentMethod)) {
      setMethods([...methods, ...paymentMethod]);
    } else {
      setMethods([...methods, paymentMethod]);
    }
    handleAddPaymentMethodModal();
  };

  const handleDeletePaymentMethodModal = (paymentMethod = null) => {
    setPaymentMethodToDelete(paymentMethod);
    setShowConfirmDeletePaymentMethodModal(
      !showConfirmDeletePaymentMethodModal
    );
  };

  const deletePaymentMethod = (paymentMethodId) => {
    console.log("deletePaymentMethod paymentMethod", paymentMethodId);
    const updatedPaymentMethods = methods.filter(
      (method) => method.id !== paymentMethodId
    );
    setMethods(updatedPaymentMethods);
    setPaymentMethods(updatedPaymentMethods);
    setShowConfirmDeletePaymentMethodModal(false);
  };

  const handleAddPaymentMethodModal = () => {
    if (amountToPay <= 0) {
      return dispatchAddAlert({
        message: ORDER_WITH_FULL_PAYMENTS,
      });
    }
    setShowAddPaymentMethodModal(!showAddPaymentMethodModal);
  };

  const addDiscount = (discount) => {
    if (setDiscounts) {
      setDiscounts(discount);
    }
    setDiscountsSelected([...discountsSelected, discount]);
    handleAddDiscountModal();
  };

  const deleteDiscount = (discountId) => {
    if (removeDiscounts) {
      removeDiscounts(discountId);
    }
    filterDiscounts();
  };

  const filterDiscounts = (discountId) => {
    const updatedDiscounts = discountsSelected.filter(
      (discount) => discount.id !== discountId
    );
    setDiscountsSelected(updatedDiscounts);
  };

  const handleAddDiscountModal = () => {
    setShowAddDiscountModal(!showAddDiscountModal);
  };

  const handleContinue = () => {
    // const isValid = amountToPay <= 0;
    // if (!isValid) {
    //   return alert(
    //     "Selecione um método de pagamento para o valor restante à pagar"
    //   );
    // }

    return continueAction();
  };

  return (
    <>
      {allowDiscountEdit && (
        <Box>
          <DarkGreyBox>
            <Typography variant="body1">Descontos</Typography>
          </DarkGreyBox>

          <Grid
            container
            spacing={2}
            sx={{
              p: 1,
            }}
          >
            <Grid item xs={12} sm={4} md={2}>
              <IconStackButtonFullHeight
                padding={60}
                onClick={handleAddDiscountModal}
              >
                <Card
                  variant="elevation"
                  elevation={0}
                  sx={{
                    p: 4,
                  }}
                >
                  <Stack spacing={1} justifyContent="center" display="flex">
                    <Box>
                      <DiscountIcon />
                    </Box>
                    <Typography variant="body1">Adicionar Desconto</Typography>
                  </Stack>
                </Card>
              </IconStackButtonFullHeight>
            </Grid>
            {discountsSelected.map((discount) => {
              return (
                <Grid item xs={12} sm={4} md={2}>
                  <IconStackButtonFullHeight
                    padding={60}
                    onClick={() => deleteDiscount(discount.id)}
                  >
                    <Card
                      variant="elevation"
                      elevation={0}
                      sx={{
                        p: 4,
                      }}
                    >
                      <Stack spacing={1} justifyContent="center" display="flex">
                        <Box>
                          <DiscountIcon />
                        </Box>
                        <Typography variant="body1">
                          {discount.type === "PERCENTAGE"
                            ? `(${discount.type_value}%)`
                            : null}{" "}
                          {formatFinance(discount.value)}
                        </Typography>
                        <Typography variant="body1">
                          {translateDiscountType(discount.type)}
                        </Typography>
                      </Stack>
                    </Card>
                  </IconStackButtonFullHeight>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      )}

      <DarkGreyBox>
        <Typography variant="body1">Selecione o Método de Pagamento</Typography>
      </DarkGreyBox>
      <Grid
        container
        spacing={2}
        sx={{
          p: 1,
        }}
      >
        {allowDiscountEdit && (
          <Grid item xs={12} sm={4} md={2}>
            <IconStackButtonFullHeight padding={60}>
              <Card
                variant="elevation"
                elevation={0}
                sx={{
                  p: 4,
                }}
              >
                <Stack spacing={1} justifyContent="center" display="flex">
                  <Box>
                    <AttachMoneyIcon />
                  </Box>
                  <Typography variant="body1">
                    À pagar {formatFinance(amountToPay)}
                  </Typography>
                </Stack>
              </Card>
            </IconStackButtonFullHeight>
          </Grid>
        )}
        <Grid item xs={12} sm={4} md={2}>
          <IconStackButtonFullHeight onClick={handleAddPaymentMethodModal}>
            <Card
              variant="elevation"
              elevation={0}
              sx={{
                p: 4,
              }}
            >
              <Stack spacing={1} justifyContent="center" display="flex">
                <Box>
                  <AddCircleIcon />
                </Box>
                <Typography variant="body1">
                  Adicionar Met. Pagamento
                </Typography>
              </Stack>
            </Card>
          </IconStackButtonFullHeight>
        </Grid>
        {methods.map((method) => {
          return (
            <Grid item xs={12} sm={4} md={3}>
              <IconStackButtonFullHeight
                onClick={() => handleDeletePaymentMethodModal(method)}
              >
                <Card
                  variant="elevation"
                  elevation={0}
                  sx={{
                    p: 2,
                    border: `${method.selected ? "2px solid #222" : "none"}`,
                  }}
                >
                  <Stack spacing={1} justifyContent="center" display="flex">
                    <Box>{method.icon}</Box>
                    <Typography variant="body1">
                      {cleanSpecialCharacters(
                        method.name || method.payment_method
                      )}
                    </Typography>
                    <Typography variant="body1">
                      (
                      {formatFinance(method.amount || parseFloat(method.value))}
                      )
                    </Typography>
                  </Stack>
                </Card>
              </IconStackButtonFullHeight>
            </Grid>
          );
        })}
      </Grid>

      {allowDiscountEdit && !isEdit && (
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            borderRadius: 2,
            margin: "60px 40px",
            backgroundColor: grey["100"],
          }}
        >
          <Button variant="contained" color="success" onClick={handleContinue}>
            Continuar
          </Button>
        </Box>
      )}

      {showAddPaymentMethodModal && (
        <AddPaymentMethodModal
          closeModal={handleAddPaymentMethodModal}
          showModal={showAddPaymentMethodModal}
          stillToBePaid={amountToPay}
          addPaymentMethod={addPaymentMethod}
        />
      )}

      {showAddDiscountModal && (
        <AddDiscountModal
          closeModal={handleAddDiscountModal}
          showModal={showAddDiscountModal}
          addDiscount={addDiscount}
          total={total}
        />
      )}

      {showConfirmDeletePaymentMethodModal && (
        <ConfirmModal
          show={showConfirmDeletePaymentMethodModal}
          label="Remover Método de Pagamento?"
          message={`Tem certeza que deseja remover o método de pagamento ${
            paymentMethodToDelete.payment_method || paymentMethodToDelete.name
          } no valor de ${formatFinance(
            parseFloatToFixed(
              paymentMethodToDelete.amount || paymentMethodToDelete.value
            )
          )}?`}
          action={() => deletePaymentMethod(paymentMethodToDelete.id)}
          closeModal={handleDeletePaymentMethodModal}
        />
      )}
    </>
  );
}
